
import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { getConsentStatus, setConsentStatus } from '@/utils/cookieConsent';
import { PrivacyPolicy } from '@/components/PrivacyPolicy';

export const CookieConsent = () => {
  const [show, setShow] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  useEffect(() => {
    // Check if we already have consent
    const consent = getConsentStatus();
    if (!consent) {
      setShow(true);
    }
  }, []);

  const handleConsent = (accepted: boolean) => {
    setConsentStatus(accepted ? 'accepted' : 'declined');
    setShow(false);
  };

  if (!show) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-background border-t shadow-lg"
      >
        <div className="container mx-auto max-w-7xl flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-muted-foreground">
              We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.{' '}
              <button
                onClick={() => setShowPrivacyPolicy(true)}
                className="text-primary underline hover:text-primary/80"
              >
                Privacy Policy
              </button>
            </p>
          </div>
          <div className="flex items-center gap-4">
            <Button
              variant="outline"
              onClick={() => handleConsent(false)}
            >
              Decline All
            </Button>
            <Button
              onClick={() => handleConsent(true)}
            >
              Accept All
            </Button>
          </div>
        </div>
      </motion.div>
      <PrivacyPolicy 
        open={showPrivacyPolicy} 
        onOpenChange={setShowPrivacyPolicy} 
      />
    </AnimatePresence>
  );
};
